import React from 'react';

interface GoogleSignInButtonProps {
  className?: string;
}

const GoogleSignInButton: React.FC<GoogleSignInButtonProps> = () => {
  return null;
};

export default GoogleSignInButton;
